import { render, staticRenderFns } from "./DetailPagesMake.vue?vue&type=template&id=f0d353de&scoped=true&"
import script from "./DetailPagesMake.vue?vue&type=script&lang=js&"
export * from "./DetailPagesMake.vue?vue&type=script&lang=js&"
import style0 from "./DetailPagesMake.vue?vue&type=style&index=0&id=f0d353de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d353de",
  null
  
)

export default component.exports